import StatCard from './StatCard';
import { useSelector } from 'react-redux';
import { formatDateToIST, getOrderStatus } from '../../../lib/utils/utils';

const getPaymentStatusColor = (status) => {
    switch (status) {
        case 'PENDING':
            return 'text-[#92400E]';
        case 'SUCCESSFUL':
            return 'text-[#208B4C]';
        case 'CANCELLED':
            return 'text-[#991B1B]';
        case 'FAILED':
            return 'text-[#666666]';
        case 'COD':
            return 'text-[#FF9900]';
        case 'REFUNDED':
            return 'text-[#1E40AF]';
        default:
            return '';
    }
}

function OrderStats() {
    const { orderDetails } = useSelector((state) => state.orderDetails.orderDetails);
    const orderStatus = useSelector((state) => state.orderDetails.orderStatus);

    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5 mt-4">
            {
                Object.keys(orderDetails).length > 0 && 
                <>
                    <StatCard 
                        statName={'Order Placed on'} 
                        statValue={formatDateToIST(orderDetails.createdAt)} 
                    />

                    <StatCard 
                        statName={'Order Status'} 
                        statValue={getOrderStatus(orderStatus)} 
                    />

                    <StatCard 
                        statName={'Total Price'} 
                        statValue={orderDetails.total} 
                        hasPrice={true} 
                        hasDecimal={true} 
                    />

                    <StatCard 
                        statName={'Payment Status'} 
                        statValue={orderDetails.paymentStatus} 
                        color={getPaymentStatusColor(orderDetails.paymentStatus)} 
                    />
                </>
            }
        </div>
    );
}

export default OrderStats;
